/* The filter panel's field grid — the Sales lists (`/sales/orders`, `/sales/returns`,
   `/sales/counterparties`). A responsive CSS grid instead of `<Row>`/`<Col>` spans: as many
   equal columns as fit at the field's minimum width, stretched to the panel's full width, the
   columns aligned across rows; a last, partial row keeps the column width rather than stretching.
   One field per row on a phone. `FilterCell wide` is the period — two dates — which takes two
   columns wherever two fit. Styles: `.lp-fgrid*` in `list-page.scss`; spec/02 "Filter panel". */

import React from "react";

export default function FilterGrid({ children }) {
  return (
    <div className="lp-fgrid">
      <div className="lp-fgrid__grid">{children}</div>
    </div>
  );
}

export const FilterCell = ({ wide = false, children }) => <div className={wide ? "lp-fgrid__cell lp-fgrid__cell--wide" : "lp-fgrid__cell"}>{children}</div>;
